export enum PrzedsiebiorcyFilter {
  OPIEKA_NAD_DZIECKIEM_DO_LAT_3 = 'OP',
  TURNUSY_REHABILITACYJNE = 'ON',
}

export const PRZEDSIEBIORCY_FILTER_LABELS: Record<
  PrzedsiebiorcyFilter,
  string
> = {
  [PrzedsiebiorcyFilter.OPIEKA_NAD_DZIECKIEM_DO_LAT_3]:
    'Opieka nad dzieckiem do lat 3',
  [PrzedsiebiorcyFilter.TURNUSY_REHABILITACYJNE]: 'Turnusy Rehabilitacyjne',
};

export function getPrzedsiebiorcyFilterDropdownItems() {
  return Object.entries(PRZEDSIEBIORCY_FILTER_LABELS).map(([key, label]) => ({
    label,
    value: key as PrzedsiebiorcyFilter,
  }));
}
